import { render, staticRenderFns } from "./Baremetals.vue?vue&type=template&id=3d69c64a"
import script from "./Baremetals.vue?vue&type=script&lang=js"
export * from "./Baremetals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports